<div class="add-to-collection-page-container container" fxLayout="column" fxLayoutGap="15px">

  <!-- Dynamic Text with Store Count -->
  <p>
    {{ 'collection.add_message' | translate: { count: wizard.model.storeUuids.length, storeLabel: wizard.model.storeUuids.length === 1 ? 'store' : 'stores' } }}
  </p>

  <!-- Filter Input -->
  <div fxLayout="row" fxLayoutAlign="end start">
    <mtn-text-field
      [form]="form"
      controlName="filter"
      placeholder="{{ 'collection.filter_placeholder' | translate }}"
      [noErrorPadding]="true">
    </mtn-text-field>
  </div>

  <div class="container">
    <!-- Collection List -->
    <div class="collection-list-container container scrollable">
      <mat-selection-list [multiple]="false" (selectionChange)="handleSelection($event)" aria-label="Select a collection">
        <mat-list-option *ngFor="let collection of collections" [value]="collection">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">

            <!-- Folder Icon -->
            <div class="default-icon-container" fxLayoutAlign="center center">
              <fa-icon icon="folder"></fa-icon>
            </div>

            <!-- Collection Name & Description -->
            <div fxLayout="column" style="max-width: 320px;">
              <small class="text-ellipsis"><strong>{{ collection.name }}</strong></small>
              <small class="color-muted text-ellipsis" *ngIf="collection.description">{{ collection.description }}</small>
            </div>

          </div>
        </mat-list-option>
      </mat-selection-list>
      <div *ngIf="collections.length === 0 && !isLoading" class="color-muted" style="padding: 16px; text-align: center;">
        No Results Available
      </div>
    </div>

    <!-- Loading Spinner -->
    <mtn-spinner [on]="isLoading"></mtn-spinner>
  </div>

</div>
